import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileIcon } from './ui';
import { useFileSearch, useWorkspace } from '../hooks';
import { useT } from '../i18n';

/**
 * Búsqueda global.
 *
 * Con retardo antes de consultar: sin él, cada tecla sería una petición a la
 * base de datos y el resultado que se pinta sería el de una consulta que el
 * usuario ya ha dejado atrás.
 *
 * Los textos salían en inglés dentro de una interfaz en español —el catálogo ya
 * tenía las claves, sólo que nadie las usaba—, y es el elemento que más se mira
 * de la cabecera: en un teléfono ocupa media barra superior.
 */
export function GlobalSearch() {
  const t = useT();
  const { workspaceId } = useWorkspace();
  const navigate = useNavigate();
  const [texto, setTexto] = useState('');
  const [consulta, setConsulta] = useState('');
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setConsulta(texto), 300);
    return () => clearTimeout(id);
  }, [texto]);

  const { data, loading } = useFileSearch(workspaceId, consulta);
  const resultados = data?.files ?? [];

  return (
    <div className="relative w-full max-w-md">
      <input
        type="search"
        value={texto}
        onChange={(event) => setTexto(event.target.value)}
        onFocus={() => setAbierto(true)}
        onBlur={() => setTimeout(() => setAbierto(false), 150)}
        placeholder={t('nav.search')}
        aria-label={t('nav.search')}
        className="w-full rounded-xl border border-line-strong bg-surface-2/50 px-3 py-2 text-sm placeholder:text-muted focus:border-primary-soft"
      />

      {abierto && consulta.trim().length >= 2 ? (
        <div className="absolute left-0 right-0 top-full z-40 mt-2 overflow-hidden rounded-xl border border-line/60 bg-surface shadow-card animate-slide-up">
          {loading ? (
            <p className="px-3 py-4 text-sm text-muted">{t('nav.searching')}</p>
          ) : resultados.length === 0 ? (
            <p className="px-3 py-4 text-sm text-muted">{t('nav.noMatches')}</p>
          ) : (
            resultados.slice(0, 8).map((file) => (
              <button
                key={file.id}
                type="button"
                onMouseDown={() => navigate(`/files?file=${file.id}`)}
                className="flex w-full items-center gap-3 px-3 py-2 text-left hover:bg-surface-2"
              >
                <FileIcon mimeType={file.mimeType} name={file.name} size="sm" />
                <span className="min-w-0 flex-1 truncate text-sm">{file.name}</span>
              </button>
            ))
          )}
        </div>
      ) : null}
    </div>
  );
}
